(function($) {

    const priceOffer = (string) => {

        let cond = false;

        if( $('body').hasClass('en') ) {

            if ( string.toLowerCase().indexOf('cost') > -1 ||
            string.toLowerCase().indexOf('price') > -1 ) {
                cond = true;
            }
        }
        else if ( $('body').hasClass('fr') ) {

            if ( string.toLowerCase().indexOf('coût') > -1 ||
            string.toLowerCase().indexOf('prix') > -1 ||
            string.toLowerCase().indexOf('cout') > -1 ) {
                cond = true;
            }
        }
        else {

            if ( string.toLowerCase().indexOf('costo') > -1 ||
            string.toLowerCase().indexOf('precio') > -1 ) {
                cond = true;
            }
        }

        if ( cond ) {
            window.location.replace(designerURL);
        }

        return cond;
    }

    $(document).on('submit', '.mobile-menu-search form', function(e) {

        if ( priceOffer( $(this).find('[name="s"]').val() ) ) {
            e.preventDefault();
        }
    });

})(jQuery);
